import React from 'react';
import { Collapse, InputNumber, Slider } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

function PerformanceSection({ config, updateConfig }) {
  return (
    <Collapse
      ghost
      style={{ marginBottom: '24px' }}
    >
      <Panel
        header={
          <span style={{ fontSize: '14px', fontWeight: 600, letterSpacing: '0.3px', color: '#262626' }}>
            <ThunderboltOutlined /> PERFORMANCE SETTINGS
          </span>
        }
        key="performance"
      >
        <div style={{ padding: '4px 0' }}>
          {/* Max Document Size */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
              Max Payload Size (KB)
            </label>
            <InputNumber
              min={64}
              max={2048}
              step={64}
              value={config.max_doc_size_kb || 256}
              onChange={(value) => updateConfig('max_doc_size_kb', value)}
              style={{ width: '200px' }}
              size="large"
            />
            <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
              Payloads larger than this are truncated before scanning (prevents timeouts)
            </div>
          </div>

          {/* Sampling Rate for Hybrid Mode */}
          {config.pii_scanning_mode === 'hybrid' && (
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                Hybrid Mode Sampling Rate: {Math.round((config.sampling_rate || 0.1) * 100)}%
              </label>
              <Slider
                min={0.05}
                max={0.5}
                step={0.05}
                value={config.sampling_rate || 0.1}
                onChange={(value) => updateConfig('sampling_rate', value)}
                marks={{
                  0.05: { label: <span style={{ fontSize: '11px' }}>5%</span> },
                  0.25: { label: <span style={{ fontSize: '11px' }}>25%</span> },
                  0.5: { label: <span style={{ fontSize: '11px' }}>50%</span> }
                }}
                trackStyle={{ backgroundColor: '#1890ff', height: 4 }}
                handleStyle={{ borderColor: '#1890ff', height: 16, width: 16, marginTop: -6, backgroundColor: '#fff' }}
                railStyle={{ height: 4, backgroundColor: '#e8e8e8' }}
              />
              <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
                Percentage of events scanned when using hybrid mode (trust app instrumentation but verify with sampling)
              </div>
            </div>
          )}
        </div>
      </Panel>
    </Collapse>
  );
}

export default PerformanceSection;
